"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const founders = [{
  name: "Steven Schnidrig",
  role: "GESCHÄFTSFÜHRER & SYSTEMINTEGRATION",
  bio: "Als Techniker mit Hintergrund in der Industrieautomation bringt Steven das nötige Know-how mit, um Gebäudesysteme so zu denken wie sie wirklich funktionieren – präzise, zuverlässig und durchdacht. Von der Planung bis zur Inbetriebnahme begleitet er jedes Projekt persönlich und sorgt dafür, dass alles sauber zusammenspielt.",
  image: "https://selected-skink.10web.cloud/wp-content/uploads/2026/03/20260301_171003-scaled.jpg?v=z7vgpl5qqh"
}, {
  name: "Thierry Lochmatter",
  role: "MITINHABER & SOFTWARE-SPEZIALIST",
  bio: "Als erfahrener Softwareentwickler mit Wurzeln in der Industrieautomation ist Thierry zuständig wenn es technisch anspruchsvoll wird. Komplexe Schnittstellen, systemübergreifende Integrationen und massgeschneiderte Softwarelösungen – er findet einen Weg, auch dann wenn Standard-Lösungen nicht mehr weiterhelfen.",
  image: "https://selected-skink.10web.cloud/wp-content/uploads/2026/03/2025-12studio.vorbenJCIVorstand2026-3.webp?v=fegcvaydyfo"
}];
export default function TheFounders() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="die-gründer" ref={ref} className={cn("dark bg-background text-foreground py-24 relative overflow-hidden", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10", "transition-all duration-1000 ease-out")}>
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24 max-w-5xl mx-auto">
          {founders.map((founder, i) => <div key={i} data-index={i} className="flex flex-col gap-6 group">
              {}
              <div className="relative aspect-[3/4] w-full overflow-hidden bg-muted rounded-lg">
                <img src={founder.image} alt={founder.name} className="h-full w-full object-cover grayscale contrast-110 transition-transform duration-700 group-hover:scale-105 group-hover:grayscale-0" />
                {}
                <div className="absolute inset-0 ring-1 ring-border/50 pointer-events-none" />
              </div>

              {}
              <div className="flex flex-col gap-2 text-left">
                <h3 className="text-2xl font-bold text-foreground tracking-tight">
                  {founder.name}
                </h3>
                <p className="text-primary font-medium text-sm uppercase tracking-wider">
                  {founder.role}
                </p>
                <p className="text-muted-foreground leading-relaxed max-w-md">
                  {founder.bio}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}